import axiosInstance from '../axios/axios-instance';
import { JourneyDto, JourneyListResponseDto } from 'shared/interfaces/engagement/journey/journey.interface';

const journeyPath = (journeyId: string) => `/engagement/journeys/${encodeURIComponent(journeyId)}`;

export const journeysApi = {
  async list(status: 'active' | 'archived' = 'active'): Promise<JourneyListResponseDto> {
    const response = await axiosInstance.get<JourneyListResponseDto>('/engagement/journeys', {
      params: { status },
    });
    return response.data;
  },

  async get(journeyId: string): Promise<JourneyDto> {
    const response = await axiosInstance.get<JourneyDto>(journeyPath(journeyId));
    return response.data;
  },

  async pin(journeyId: string): Promise<JourneyDto> {
    const response = await axiosInstance.post<JourneyDto>(`${journeyPath(journeyId)}/pin`);
    return response.data;
  },

  async unpin(journeyId: string): Promise<JourneyDto> {
    const response = await axiosInstance.delete<JourneyDto>(`${journeyPath(journeyId)}/pin`);
    return response.data;
  },

  async setTarget(journeyId: string, target: string | null): Promise<JourneyDto> {
    const response = await axiosInstance.put<JourneyDto>(`${journeyPath(journeyId)}/target`, { target });
    return response.data;
  },

  async setReminder(journeyId: string, reminderOn: string | null): Promise<JourneyDto> {
    const response = await axiosInstance.put<JourneyDto>(`${journeyPath(journeyId)}/reminder`, { reminderOn });
    return response.data;
  },

  async archive(journeyId: string): Promise<JourneyDto> {
    const response = await axiosInstance.post<JourneyDto>(`${journeyPath(journeyId)}/archive`);
    return response.data;
  },
};
